// get_expert_marketplaces
export const GET_EXPERT_MARKETPLACES = 'get_expert_marketplaces';
export const GET_EXPERT_MARKETPLACES_SUCCESSFUL =
  'get_expert_marketplaces_successfull';
export const GET_EXPERT_MARKETPLACES_FAILED = 'get_expert_marketplaces_failed';

// delete_expert_marketplace
export const DELETE_EXPERT_MARKETPLACE = 'delete_expert_marketplace';
export const DELETE_EXPERT_MARKETPLACE_SUCCESSFUL =
  'delete_expert_marketplace_successfull';
export const DELETE_EXPERT_MARKETPLACE_FAILED =
  'delete_expert_marketplace_failed';
// submit_marketplace_overview
export const SUBMIT_MARKETPLACE_OVERVIEW = 'submit_marketplace_overview';
export const SUBMIT_MARKETPLACE_OVERVIEW_SUCCESSFUL =
  'submit_marketplace_overview_successfull';
export const SUBMIT_MARKETPLACE_OVERVIEW_FAILED =
  'submit_marketplace_overview_failed';

// submit_marketplace_pricing
export const SUBMIT_MARKETPLACE_PRICING = 'submit_marketplace_pricing';
export const SUBMIT_MARKETPLACE_PRICING_SUCCESSFUL =
  'submit_marketplace_pricing_successfull';
export const SUBMIT_MARKETPLACE_PRICING_FAILED =
  'submit_marketplace_pricing_failed';

// submit_marketplace_faq
export const SUBMIT_MARKETPLACE_FAQ = 'submit_marketplace_faq';
export const SUBMIT_MARKETPLACE_FAQ_SUCCESSFUL =
  'submit_marketplace_faq_successfull';
export const SUBMIT_MARKETPLACE_FAQ_FAILED = 'submit_marketplace_faq_failed';

// submit_marketplace_gallery
export const SUBMIT_MARKETPLACE_GALLERY = 'submit_marketplace_gallery';
export const SUBMIT_MARKETPLACE_GALLERY_SUCCESSFUL =
  'submit_marketplace_gallery_successfull';
export const SUBMIT_MARKETPLACE_GALLERY_FAILED =
  'submit_marketplace_gallery_failed';

// get_expertise_submissions
export const GET_EXPERTISE_SUBMISSIONS = 'get_expertise_submissions';
export const GET_EXPERTISE_SUBMISSIONS_SUCCESSFUL =
  'get_expertise_submissions_successfull';
export const GET_EXPERTISE_SUBMISSIONS_FAILED =
  'get_expertise_submissions_failed';

// delete_expertise_submission
export const DELETE_EXPERTISE_SUBMISSION = 'delete_expertise_submission';
export const DELETE_EXPERTISE_SUBMISSION_SUCCESSFUL =
  'delete_expertise_submission_successfull';
export const DELETE_EXPERTISE_SUBMISSION_FAILED =
  'delete_expertise_submission_failed';

// get_marketplace
export const GET_MARKETPLACE = 'get_marketplace';
export const GET_MARKETPLACE_SUCCESSFUL = 'get_marketplace_successfull';
export const GET_MARKETPLACE_FAILED = 'get_marketplace_failed';
